<!--
 * @Description: 复制商机
-->
<template>
  <CosLayoutMain>
    <template #content>
      <BusinessForm ref="businessFormRef" title="复制商机" type="copy" v-model:value="dataForm" @update:value="fetch" :originalStatus="originalStatus"  @planSaleAmount="planSaleAmount"/>
    </template>
    <template #footer>
      <a-button @click="goBack()">取消</a-button>
      <a-button :loading="loading" @click="handleReset()">重置</a-button>
      <a-button type="primary" :loading="loading" @click="handleSubmit()">保存</a-button>
    </template>
  </CosLayoutMain>
</template>

<script setup lang="ts">
import { ref, reactive, toRaw, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { cloneDeep } from 'lodash-es'
import { message } from '@dc-platform/dc-components'
import BusinessForm from './components/BusinessForm.vue'
import { goBack } from '@/hooks/cosRouter'
import { businessCreateOrEdit, businessDetails } from '@/api/gucangSales/chanceManage'
import type { FbuBusinessEditParams } from '@/typings/api/chanceManage'
const route = useRoute()
const lastPlanSaleAmount = ref<number>()
const initForm: FbuBusinessEditParams = reactive({})
const dataForm = reactive<FbuBusinessEditParams>({})
const originalStatus = ref<number>()
onBeforeMount(() => {
  businessDetails({ id: route.query.id }).then((res) => {
    res.data.id = undefined
    res.data.createTime = undefined
    res.data.createByName = undefined
    res.data.createBy = undefined
    /// 此时默认为达成合作
    res.data.status = 5
    originalStatus.value = res.data.status
    res.data.tailWarehouse = res.data.tailWarehouse || undefined
    res.data.tailProductName = res.data.tailProductName || undefined
    Object.assign(initForm, res.data)
    Object.assign(dataForm, res.data)
  })
})

const fetch = (val: any) => {
  Object.assign(dataForm, val)
}
const planSaleAmount = (val: any) => {
  lastPlanSaleAmount.value = val
}
const businessFormRef = ref()
const handleReset = () => {
  for (const key in dataForm) {
    dataForm[key] = undefined
  }
  Object.assign(dataForm, cloneDeep(initForm))
  setTimeout(() => {
    businessFormRef.value?.clearValidate()
  })
}
const loading = ref(false)
const handleSubmit = () => {
  businessFormRef.value?.validate().then(() => {
    const last = lastPlanSaleAmount.value
    if (last) {
      if (dataForm.planSaleAmount && dataForm.planSaleAmount <= last) {
        message.error('【预计月销售额】需高于上次完结状态的相同商机的预计月销售额')
        return
      }
    }
    loading.value = true
    const params = toRaw(dataForm)
    businessCreateOrEdit(params)
      .then(() => {
        message.success('新增成功')
        businessFormRef.value?.resetFields()
        goBack()
      })
      .finally(() => {
        loading.value = false
      })
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosFbuBusinessCopy' }
</script>

<style scoped></style>
